import { ROUTES } from "app/helpers/routerPathHelper";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const FooterLinks = (): React.JSX.Element => {
  return (
    <div className="links">
      <span title="aboutus">
        <Link to={ROUTES.asianHelpAndLearningAboutUsLicenceInformation}>
          <FormattedMessage tagName="span" id="helpandlearning-aboutus" />
        </Link>
      </span>
      <span title="termsandconditions">
        <Link to={ROUTES.asianHelpAndLearningTermsAndConditions}>
          <FormattedMessage
            tagName="span"
            id="helpandlearning-termsandconditions"
          />
        </Link>
      </span>
      <span title="responsiblegaming">
        <Link to={ROUTES.asianHelpAndLearningResponsibleGaming}>
          <FormattedMessage
            tagName="span"
            id="helpandlearning-responsiblegaming"
          />
        </Link>
      </span>
      <span title="privacypolicy">
        <Link to={ROUTES.asianHelpAndLearningTermsAndConditionsPrivacyPolicy}>
          <FormattedMessage
            tagName="span"
            id="helpandlearning-termsandconditions-privacypolicy"
          />
        </Link>
      </span>
      <span title="helpandlearning">
        <Link to={ROUTES.asianHelpAndLearning}>
          <FormattedMessage
            tagName="span"
            id="helpandlearning-welcome-helpandlearning"
          />
        </Link>
      </span>
      <span title="contactus">
        <Link to={ROUTES.asianHelpAndLearningContactAndSupportContactUs}>
          <FormattedMessage
            tagName="span"
            id="helpandlearning-contactandsupport-contactus"
          />
        </Link>
      </span>
    </div>
  );
};

export default FooterLinks;
